import { Modal, Input, Form } from "antd";
import { useState } from "react";
import { toast } from "react-toastify";
import { Method_POST_PDF } from "../../../../../service/api";

const { confirm } = Modal;

export function useLivroRazaoDownload({ dataInicio, dataTermino, nomeLancamento, contaContabilId, valor }) {
  const [form] = Form.useForm();

  const downloadPdf = (fileData, filename = "livro-razao.pdf") => {
    const blob = new Blob([fileData], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    toast.success("Download iniciado!");
  };

  const download = async ({ incluirAssinatura, numeroLivro }) => {
    if (incluirAssinatura && !numeroLivro) {
      toast.error("O número do livro é obrigatório!");
      return;
    }

    const payload = {
      dataReferencia: dataInicio,
      dataTermino: dataTermino,
      nome: nomeLancamento || "",
      valor: valor || "",
      contaContabilDebito: { id: contaContabilId || "" },
    };

    const url = `/empresa/contabilidade/create/razao?assinatura=${incluirAssinatura}&livro=${numeroLivro || ""}`;

    try {
      const fileData = await Method_POST_PDF(url, payload, "blob");
      if (!fileData) {
        toast.error("A API não retornou um arquivo.");
        return;
      }
      downloadPdf(fileData);
    } catch (err) {
      console.error("Erro no download:", err);
      toast.error("Erro ao baixar o relatório.");
    }
  };

  const showConfirm = () => {
    form.resetFields();

    confirm({
      title: "Deseja incluir a assinatura no relatório?",
      icon: null,
      content: (
        <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
          <Form.Item
            name="numeroLivro"
            label="Número do livro (apenas para assinatura)"
            rules={[{ required: false }]}
          >
            <Input placeholder="Ex: 001" size="large" />
          </Form.Item>
        </Form>
      ),
      okText: "Gerar com Assinatura",
      cancelText: "Gerar sem Assinatura",
      okButtonProps: { size: 'large', type: 'primary' },
      cancelButtonProps: { size: 'large' },
      width: 500,
      onOk: async () => {
        try {
          const values = await form.validateFields();
          await download({ incluirAssinatura: true, numeroLivro: values.numeroLivro });
        } catch (err) {
          // Se for erro de validação, o Ant Design já mostra a mensagem no form
          return Promise.reject();
        }
      },
      onCancel: () => {
        download({ incluirAssinatura: false });
      },
    });
  };

  return { showConfirm };
}
